var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 181,
    viewBox: "0 0 181 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 90.5,
    r: 90.5,
    fill: "#071A32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.963 82.0708H97.9291V99.1042H114.963V82.0708Z",
    fill: "url(#paint0_linear_2741_42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 99.104H114.967V116.137H132V99.104Z",
    fill: "url(#paint1_linear_2741_42)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0334 116.142V99.1042V82.0708V65.0334H97.9292H114.967V48H97.9292H65.0334H48V65.0334V82.0708V99.1042V116.142V133.175H65.0334H97.9292H114.967V116.142H97.9292H65.0334Z",
    fill: "url(#paint2_linear_2741_42)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132 65.0337H114.967V82.0671H132V65.0337Z",
    fill: "url(#paint3_linear_2741_42)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2741_42",
    x1: 100.619,
    y1: 82.0708,
    x2: 113.291,
    y2: 85.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2741_42",
    x1: 117.656,
    y1: 99.104,
    x2: 130.329,
    y2: 102.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2741_42",
    x1: 58.5737,
    y1: 48,
    x2: 109.555,
    y2: 58.0849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2741_42",
    x1: 117.656,
    y1: 65.0337,
    x2: 130.329,
    y2: 68.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F981"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBIcon);
export default __webpack_public_path__ + "static/media/B-Icon.7ed4ebe4fe4fe19fe618ce08394d6e23.svg";
export { ForwardRef as ReactComponent };